const ProductPage = () => {
  return null;
};

export default ProductPage;
